export const OBJECT_TYPES = {
  TP: {
    typecode: 11,
    label: 'ТП',
    titlePrefix: 'ТП-',
    buttonKey: 'TP',
    hasLinkedtp: true,
    checkDuplicateEndpoint: 'getTPbyName',
  },
  RP: {
    typecode: 24,
    label: 'РП',
    titlePrefix: '',
    buttonKey: 'RP',
    hasLinkedtp: true,
    checkDuplicateEndpoint: 'getRPbyName',
  },
  RECLOSER: {
    typecode: 25,
    label: 'Реклоузер',
    titlePrefix: '',
    buttonKey: 'Recloser',
    hasLinkedtp: true,
    checkDuplicateEndpoint: 'getRecloserbyName',
  },
};